import { parseSiteOrigin } from "./site-url";

const siteUrl =
  import.meta.env?.VITE_AUDIOCN_SITE_URL ?? "https://audiocn-solid.workers.dev";

export const siteConfig = {
  description:
    "Copy-and-paste audio components for Solid. Build mixers, players, meters, knobs and waveforms with accessible UI you own.",
  githubRepo: "jhomra21/audiocn-solid",
  name: "audiocn Solid",
  registryNamespace: "@audiocn-solid",
  title: "audiocn Solid — Audio components for Solid",
  url: parseSiteOrigin(siteUrl),
} as const;
